export class TemplateComponentVariable {
  constructor(
    public id: number,
    public displayLabel: string,
    public format: string,
    public sampleContent: string,
    public sampleContentHtml: string,
    public productLine: string,
    public source: string
  ) {}
}
